import React from 'react';
import HomeMessageBoard from './HomeMessageBoard';

const PublicMessage = () => {
    return (
        <div className="col-sm-8">
            <div className="shadow hm-tag public-msg-wrap">
                <HomeMessageBoard />
            </div>
        </div>
    )
}

export default PublicMessage
